module.exports = __webpack_public_path__ + "static/img/icon1.b1068d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/icon1.png
// module id = w3My
// module chunks = 3